import { ForwardedRef, forwardRef, useState } from "react";
import * as s from "styles/ModalCommonStyled";
import { SearchUserList } from "./SearchUserList";
import { SearchUserGroup } from "./SearchUserGroup";
import DebounceSearchInput from "components/atoms/input/search/DebounceSearchInput";
import {
  AlertRuleGroupRecipients,
  AlertRuleRecipients,
} from "api/interfaces/alertInterface.interface";
import Tabs from "components/atoms/tabs/Tabs";

export type SearchUserProps = {
  accountId: string;
  placeholder?: string;
  selectedUserId?: string[];
  selectedUserGroupId?: string[];
  enableCheckUserList?: AlertRuleRecipients[];
  enableCheckUserGroupList?: AlertRuleGroupRecipients[];
  isTab?: boolean;
  onSelectedRowsChangeUser?: (selectedRows: string[]) => void;
  onSelectedRowsChangeUserGroup?: (selectedRows: string[]) => void;
  onChangeEnableCheckUserList?: (selectedRows: AlertRuleRecipients[]) => void;
  onChangeEnableCheckUserGroup?: (
    selectedRows: AlertRuleGroupRecipients[]
  ) => void;
  isSupportEmail?: boolean;
  userGroupId?: string;
  isEditUserGroup?: boolean;
  previlege?: string;
};

const enum USER_MENU {
  USERS = "users",
  USER_GROUPS = "userGroups",
}

export const SearchUsers = forwardRef(
  (props: SearchUserProps, ref: ForwardedRef<any>): JSX.Element => {
    const [searchText, setSearchText] = useState<string>("");

    const onClickSearch = (keyword: string) => {
      setSearchText(keyword);
    };

    // step 2 - recipients sub menu
    const recipientsMenus = [
      {
        label: "Add Users",
        value: USER_MENU.USERS,
        placeholder: "Search Users",
      },
      {
        label: "Add User Groups",
        value: USER_MENU.USER_GROUPS,
        placeholder: "Search Groups",
      },
    ];
    const [currentMenu, setCurrentMenu] = useState<USER_MENU>(USER_MENU.USERS);
    const onChangeMenu = (value: string) => {
      setCurrentMenu(value as USER_MENU);
    };

    //FIXME EDIT시 기존에 체크된 User정보를 테이블에 적용하는 로직 필요.
    return (
      <>
        {props.isTab ? (
          <s.ModalTabSearchWrapper>
            <Tabs
              tabs={recipientsMenus}
              currentTab={currentMenu.toString()}
              onChangeTab={onChangeMenu}
            />
            <div className="search-box">
              <DebounceSearchInput
                placeholder={
                  recipientsMenus.find((menu) => menu.value === currentMenu)
                    ?.placeholder
                }
                onClickSearch={onClickSearch}
              />
            </div>
          </s.ModalTabSearchWrapper>
        ) : (
          <DebounceSearchInput
            placeholder={
              recipientsMenus.find((menu) => menu.value === currentMenu)
                ?.placeholder
            }
            onClickSearch={onClickSearch}
          />
        )}
        <s.ModalTableContainer>
          {currentMenu === USER_MENU.USERS && (
            <div>
              <SearchUserList
                accountId={props.accountId}
                keyword={searchText}
                onSelectedRowsChangeUser={props.onSelectedRowsChangeUser}
                onChangeEnableCheckUserList={props.onChangeEnableCheckUserList}
                selectedUserId={props.selectedUserId}
                isSupportEmail={props.isSupportEmail}
                userGroupId={props.userGroupId}
                enableCheckUserList={props.enableCheckUserList}
                isEditUserGroup={props.isEditUserGroup}
                previlege={props.previlege}
              />
            </div>
          )}
          {currentMenu === USER_MENU.USER_GROUPS && (
            <div>
              <SearchUserGroup
                accountId={props.accountId}
                keyword={searchText}
                onSelectedRowsChangeUserGroup={
                  props.onSelectedRowsChangeUserGroup
                }
                onChangeEnableCheckUserGroup={
                  props.onChangeEnableCheckUserGroup
                }
                selectedUserGroupId={props.selectedUserGroupId}
                enableCheckUserGroupList={props.enableCheckUserGroupList}
                isSupportEmail={props.isSupportEmail}
                previlege={props.previlege}
              />
            </div>
          )}
        </s.ModalTableContainer>
      </>
    );
  }
);
